<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal(false)" tabindex="-1" id="ticketModal" aria-labelledby="ticketModalLabel">
    <div class="modal-dialog modal-lg">
      <div v-if="loaded" class="modal-content shadow-none">
        <loader />
      </div>
      <div v-else class="modal-content shadow-none">
        <div class="modal-header p-5">
          <h5 class="modal-title">{{ ticket.code ? 'Абонемент: ' + ticket.code : 'Абонемент' }}</h5>
          <div @click="closeModal(false)" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div class="col-md-6">
              <input-field
                v-model="ticket.code"
                :required="true"
                id="ticket.code"
                name="ticket.code"
                placeholder="Код"
                type="text"
                mb="5"
              />
            </div>
            <div class="col-md-6">
              <input-field
                v-model="ticket.label.value"
                :required="true"
                id="ticket.label.value"
                name="ticket.label.value"
                placeholder="Название"
                type="text"
                mb="5"
              />
            </div>
          </div>

          <div class="mb-5">
            <div class="fs-6 fw-bold mb-3">Локализация название</div>
            <div class="row">
              <div class="col-md-4">
                <input-field
                    v-model="getI18nItemByLocale(ticket.label.i18n, 'ru-RU').value"
                    id="ticket.label.i18n.ru"
                    name="ticket.label.i18n.ru"
                    placeholder="Русский (ru-RU)"
                    type="text"
                    mb="5"
                />
              </div>
              <div class="col-md-4">
                <input-field
                    v-model="getI18nItemByLocale(ticket.label.i18n, 'uz-UZ').value"
                    id="ticket.label.i18n.uz"
                    name="ticket.label.i18n.uz"
                    placeholder="Узбекский (uz-UZ)"
                    type="text"
                    mb="5"
                />
              </div>
              <div class="col-md-4">
                <input-field
                    v-model="getI18nItemByLocale(ticket.label.i18n, 'en-US').value"
                    id="ticket.label.i18n.en"
                    name="ticket.label.i18n.en"
                    placeholder="Английский (en-US)"
                    type="text"
                    mb="5"
                />
              </div>
            </div>
          </div>
          
          <div class="mb-5">
            <div class="fs-6 fw-bold mb-3">Валюта (Currency)</div>
            <div class="row">
              <div class="col-md-6">
                <currency-field
                  v-model="ticket.nominal.value"
                  id="ticket.nominal.value"
                  name="ticket.nominal.value"
                  placeholder="Номинал"
                  mb="5"
                />
              </div>
              <div v-if="dCurrency" class="col-md-6">
                <div v-if="ticketId" class="custom-select dynamic mb-5">
                  <label for="ticket.nominal.currency.code" class="required">Код валюты</label>
                  <v-select
                      v-model="ticket.nominal.currency.code"
                      input-id="ticket.nominal.currency.code"
                      :loading="!dCurrency"
                      :disabled="!dCurrency"
                      :options="formattedCurrencyOptions"
                      :reduce="item => item.code"
                      @option:selected="onCurrencySelected"
                      :required="true"
                      placeholder="Выберите..."
                      class="mb-3 bg-gray-100 form rounded"
                      label="label"
                  />
                </div>
                <div v-else class="custom-select dynamic mb-5">
                  <label for="ticket.nominal.currencyCode" class="required">Код валюты</label>
                  <v-select
                      v-model="ticket.nominal.currencyCode"
                      input-id="ticket.nominal.currencyCode"
                      :loading="!dCurrency"
                      :disabled="!dCurrency"
                      :options="formattedCurrencyOptions"
                      :reduce="item => item.code"
                      @option:selected="onCurrencySelected"
                      :required="true"
                      placeholder="Выберите..."
                      class="mb-3 bg-gray-100 form rounded"
                      label="label"
                  />
                </div>
              </div>
            </div>
            <hr class="border-gray-400 mb-10">
            <div v-if="false" class="row">
              <div class="col-md-4">
                <input-field
                  v-model="ticket.nominal.currency.label"
                  id="ticket.nominal.currency.label"
                  name="ticket.nominal.currency.label"
                  placeholder="Название"
                  type="text"
                  mb="5"
                />
              </div>
              <div class="col-md-4">
                <input-field
                  v-model="ticket.nominal.currency.description"
                  id="ticket.nominal.currency.description"
                  name="ticket.nominal.currency.description"
                  placeholder="Описание"
                  type="text"
                  mb="5"
                />
              </div>
              <div class="col-md-4">
                <input-field
                  v-model="ticket.nominal.currency.image"
                  id="ticket.nominal.currency.image"
                  name="ticket.nominal.currency.image"
                  placeholder="Изображение валюты (URL)"
                  type="text"
                  mb="5"
                />
              </div>
            </div>
            <div v-if="false" class="fs-7 fw-bold mb-2">Локализация валюты</div>
            <div v-if="false" class="row">
              <div class="col-md-4">
                <div class="border rounded p-3 mb-3">
                  <div class="fs-7 fw-bold mb-2">Русский (ru-RU)</div>
                  <input-field
                    v-model="getI18nItemByLocale(ticket.nominal.currency.i18n, 'ru-RU').label"
                    id="ticket.nominal.currency.i18n.ru.label"
                    name="ticket.nominal.currency.i18n.ru.label"
                    placeholder="Название"
                    type="text"
                    mb="5"
                  />
                  <input-field
                    v-model="getI18nItemByLocale(ticket.nominal.currency.i18n, 'ru-RU').description"
                    id="ticket.nominal.currency.i18n.ru.description"
                    name="ticket.nominal.currency.i18n.ru.description"
                    placeholder="Описание"
                    type="text"
                    mb="5"
                  />
                  <input-field
                    v-model="getI18nItemByLocale(ticket.nominal.currency.i18n, 'ru-RU').image"
                    id="ticket.nominal.currency.i18n.ru.image"
                    name="ticket.nominal.currency.i18n.ru.image"
                    placeholder="Изображение (URL)"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="border rounded p-3 mb-3">
                  <div class="fs-7 fw-bold mb-2">Узбекский (uz-UZ)</div>
                  <input-field
                    v-model="getI18nItemByLocale(ticket.nominal.currency.i18n, 'uz-UZ').label"
                    id="ticket.nominal.currency.i18n.uz.label"
                    name="ticket.nominal.currency.i18n.uz.label"
                    placeholder="Название"
                    type="text"
                    mb="5"
                  />
                  <input-field
                    v-model="getI18nItemByLocale(ticket.nominal.currency.i18n, 'uz-UZ').description"
                    id="ticket.nominal.currency.i18n.uz.description"
                    name="ticket.nominal.currency.i18n.uz.description"
                    placeholder="Описание"
                    type="text"
                    mb="5"
                  />
                  <input-field
                    v-model="getI18nItemByLocale(ticket.nominal.currency.i18n, 'uz-UZ').image"
                    id="ticket.nominal.currency.i18n.uz.image"
                    name="ticket.nominal.currency.i18n.uz.image"
                    placeholder="Изображение (URL)"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="border rounded p-3 mb-3">
                  <div class="fs-7 fw-bold mb-2">Английский (en-US)</div>
                  <input-field
                    v-model="getI18nItemByLocale(ticket.nominal.currency.i18n, 'en-US').label"
                    id="ticket.nominal.currency.i18n.en.label"
                    name="ticket.nominal.currency.i18n.en.label"
                    placeholder="Название"
                    type="text"
                    mb="5"
                  />
                  <input-field
                    v-model="getI18nItemByLocale(ticket.nominal.currency.i18n, 'en-US').description"
                    id="ticket.nominal.currency.i18n.en.description"
                    name="ticket.nominal.currency.i18n.en.description"
                    placeholder="Описание"
                    type="text"
                    mb="5"
                  />
                  <input-field
                    v-model="getI18nItemByLocale(ticket.nominal.currency.i18n, 'en-US').image"
                    id="ticket.nominal.currency.i18n.en.image"
                    name="ticket.nominal.currency.i18n.en.image"
                    placeholder="Изображение (URL)"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-md-6">
              <currency-field
                v-model="ticket.validityPeriod"
                id="ticket.validityPeriod"
                :required="true"
                name="ticket.validityPeriod"
                placeholder="Срок действия"
                mb="5"
              />
            </div>
            <div class="col-md-6">
              <div class="custom-select dynamic mb-5">
                <label class="required" for="ticket.validityPeriodUnit">Единица срока действия</label>
                <v-select
                  v-model="ticket.validityPeriodUnit"
                  input-id="ticket.validityPeriodUnit"
                  :options="validityPeriodUnitOptions"
                  :reduce="option => option.value"
                  placeholder="Выберите..."
                  class="bg-gray-100 form rounded"
                  label="label"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <input-field
                  v-model="ticket.icon"
                  id="ticket.icon"
                  name="ticket.icon"
                  placeholder="Иконка"
                  type="text"
                  mb="5"
              />
            </div>
            <div class="col-md-6">
              <input-field
                  v-model="ticket.background"
                  id="ticket.background"
                  name="ticket.background"
                  :required="true"
                  placeholder="Фон"
                  type="text"
                  mb="5"
              />
            </div>
          </div>
          
          <div class="mb-5">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="fs-6 fw-bold">Значки (Badges)</div>
              <button class="btn btn-light btn-sm" type="button" @click="addBadge">Добавить</button>
            </div>
            <div v-for="(badge, index) in ticket.badges" :key="index" class="border rounded p-4 mb-3">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="fw-bold">Значок #{{ index + 1 }}</div>
                <button class="btn btn-icon btn-sm btn-light-danger" type="button" @click="removeBadge(index)">
                  <i class="ki-outline ki-trash fs-5"></i>
                </button>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <input-field
                      v-model="badge.code"
                      :id="`badge.${index}.code`"
                      :name="`badge.${index}.code`"
                      placeholder="Код значка"
                      type="text"
                      mb="5"
                  />
                </div>
                <div class="col-md-6">
                  <input-field
                      v-model="badge.value"
                      :id="`badge.${index}.value`"
                      :name="`badge.${index}.value`"
                      placeholder="Значение значка"
                      type="text"
                      mb="5"
                  />
                </div>
              </div>
              <div class="fs-7 fw-bold mb-2">Локализация значка</div>
              <div class="row">
                <div class="col-md-4">
                  <input-field
                    v-model="getI18nItemByLocale(badge.i18n, 'ru-RU').value"
                    :id="`badge.${index}.i18n.ru`"
                    :name="`badge.${index}.i18n.ru`"
                    placeholder="Русский (ru-RU)"
                    type="text"
                    mb="5"
                  />
                </div>
                <div class="col-md-4">
                  <input-field
                    v-model="getI18nItemByLocale(badge.i18n, 'uz-UZ').value"
                    :id="`badge.${index}.i18n.uz`"
                    :name="`badge.${index}.i18n.uz`"
                    placeholder="Узбекский (uz-UZ)"
                    type="text"
                    mb="5"
                  />
                </div>
                <div class="col-md-4">
                  <input-field
                    v-model="getI18nItemByLocale(badge.i18n, 'en-US').value"
                    :id="`badge.${index}.i18n.en`"
                    :name="`badge.${index}.i18n.en`"
                    placeholder="Английский (en-US)"
                    type="text"
                    mb="5"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mb-5">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="fs-6 fw-bold">Правила использования по дням (Daily Usage Rules)</div>
              <button class="btn btn-light btn-sm" type="button" @click="addDailyUsageRule">Добавить</button>
            </div>
            <div v-for="(rule, index) in ticket.dailyUsageRules" :key="'rule-' + index" class="border rounded p-4 mb-3">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="fw-bold">Правило #{{ index + 1 }}</div>
                <button class="btn btn-icon btn-sm btn-light-danger" type="button" @click="removeDailyUsageRule(index)">
                  <i class="ki-outline ki-trash fs-5"></i>
                </button>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="custom-select dynamic mb-5">
                    <label :for="`dailyUsageRule.${index}.dayOfWeek`">День недели</label>
                    <v-select
                      v-model="rule.dayOfWeek"
                      :input-id="`dailyUsageRule.${index}.dayOfWeek`"
                      :options="dayOfWeekOptions"
                      :reduce="item => item.value"
                      placeholder="Выберите..."
                      class="mb-3 bg-gray-100 form rounded"
                      label="label"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <input-field
                    v-model="rule.from"
                    :id="`dailyUsageRule.${index}.from`"
                    :name="`dailyUsageRule.${index}.from`"
                    placeholder="С (например 19:00)"
                    type="time"
                    :required="true"
                    mb="5"
                  />
                </div>
                <div class="col-md-4">
                  <input-field
                    v-model="rule.to"
                    :id="`dailyUsageRule.${index}.to`"
                    :name="`dailyUsageRule.${index}.to`"
                    placeholder="До (например 06:00)"
                    type="time"
                    :required="true"
                    mb="5"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer p-5 justify-content-between">
          <button type="button" @click="closeModal(false)" class="btn btn-light btn-sm">Закрыть</button>
          <button 
            v-if="ticketId" 
            type="button" 
            @click="updateTicket" 
            :disabled="saving"
            class="btn btn-primary btn-sm"
          >
            {{ saving ? 'Обновление...' : 'Обновить' }}
          </button>
          <button 
            v-else 
            type="button" 
            @click="createTicket" 
            :disabled="saving"
            class="btn btn-primary btn-sm"
          >
            {{ saving ? 'Создание...' : 'Создать' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import InputField from '@/components/Fields/InputField'
import vSelect from 'vue-select'
import CurrencyField from '@/components/Fields/CurrencyField'
import {notify} from '@kyvg/vue3-notification'
import axios from 'axios'
export default {
  name: 'TicketModal',
  components: {Loader, InputField, CurrencyField, vSelect},
  props: {
    ticketId: {
      type: String,
      default: null
    },
    dCurrency: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      loaded: false,
      saving: false,
      ticket: {
        id: null,
        code: null,
        nominal: {
          value: 0,
          currencyCode: null,
          currency: {
            code: null,
            label: null,
            description: null,
            image: null,
            i18n: [
              {
                locale: "ru-RU",
                label: null,
                description: null,
                image: null
              },
              {
                locale: "uz-UZ",
                label: null,
                description: null,
                image: null
              },
              {
                locale: "en-US",
                label: null,
                description: null,
                image: null
              },
            ]
          }
        },
        validityPeriod: 0,
        validityPeriodUnit: 'DAYS',
        label: {
          value: null,
          i18n: [
            {
              locale: "ru-RU",
              value: null
            },
            {
              locale: "uz-UZ",
              value: null
            },
            {
              locale: "en-US",
              value: null
            },
          ]
        },
        icon: null,
        background: null,
        badges: [
          {
            code: null,
            value: null,
            i18n: [
              {
                locale: "ru-RU",
                value: null
              },
              {
                locale: "uz-UZ",
                value: null
              },
              {
                locale: "en-US",
                value: null
              },
            ]
          }
        ],
        dailyUsageRules: []
      }
    }
  },
  computed: {
    dayOfWeekOptions() {
      return [
        { value: null, label: 'Каждый день' },
        { value: 'MONDAY', label: 'Понедельник (MONDAY)' },
        { value: 'TUESDAY', label: 'Вторник (TUESDAY)' },
        { value: 'WEDNESDAY', label: 'Среда (WEDNESDAY)' },
        { value: 'THURSDAY', label: 'Четверг (THURSDAY)' },
        { value: 'FRIDAY', label: 'Пятница (FRIDAY)' },
        { value: 'SATURDAY', label: 'Суббота (SATURDAY)' },
        { value: 'SUNDAY', label: 'Воскресенье (SUNDAY)' }
      ]
    },
    formattedCurrencyOptions() {
      if (!this.dCurrency || !Array.isArray(this.dCurrency)) return []
      return this.dCurrency.map(item => {
        const code = item.code || ''
        const description = item.description || item.label || item.title || ''
        const label = code && description ? `(${code}) ${description}` : (code || description || '')
        return {
          ...item,
          label: label
        }
      })
    },
    validityPeriodUnitOptions() {
      return [
        { value: 'MINUTES', label: 'Минуты (MINUTES)' },
        { value: 'HOURS', label: 'Часы (HOURS)' },
        { value: 'DAYS', label: 'Дни (DAYS)' }
      ]
    }
  },
  mounted() {
    this.normalizeI18n()
    setTimeout(() => {
      document.getElementById('ticketModal').addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('modal')) this.closeModal()
      });
    }, 10)
  },
  methods: {
    closeModal(isUpdate) {
      bootstrap.Modal.getInstance(document.getElementById('ticketModal')).hide();
      this.$emit('closeModal', isUpdate);
    },
    getTicketItem() {
      this.loaded = true
      axios.get('/api/v1/billing/issuer/tickets/specs/'+this.ticketId)
          .then(res => {
            if (res.data) {
              const data = res.data
              // Обрабатываем все поля по схеме API
              this.ticket = {
                // id (string) - Идентификатор спецификации Абонемента
                id: data.id ?? null,
                // code (string) - Код спецификации Абонемента
                code: data.code ?? null,
                // nominal (object) - Номинал Абонемента
                nominal: {
                  // value (number) - Сумма средств в указанной валюте
                  value: typeof data.nominal === 'number' ? data.nominal : (data.nominal?.value ?? 0),
                  // Синхронизируем currencyCode из данных или из currency.code
                  currencyCode: data.nominal?.currencyCode ?? data.nominal?.currency?.code ?? null,
                  // currency (object) - Валюта со всеми полями (code, label, description, image, i18n[])
                  currency: data.nominal?.currency ? {
                    code: data.nominal.currency.code ?? null,
                    label: data.nominal.currency.label ?? null,
                    description: data.nominal.currency.description ?? null,
                    image: data.nominal.currency.image ?? null,
                    i18n: data.nominal.currency.i18n ?? []
                  } : null
                },
                // validityPeriod (integer int64) - Длинна периода валидности Абонемента
                validityPeriod: data.validityPeriod ?? 0,
                // validityPeriodUnit (string, Enum: MINUTES, HOURS, DAYS) - Единица измерения периода валидности
                validityPeriodUnit: data.validityPeriodUnit ?? null,
                // label (object) - Наименование Абонемента { value, i18n[] }
                label: data.label ?? { value: null, i18n: [] },
                // icon (string) - Иконка Абонемента
                icon: data.icon ?? null,
                // background (string) - Фоновое изображение карточки Абонемента
                background: data.background ?? null,
                // badges (array) - Дополнительные атрибуты Абонемента [{ code, value, i18n[] }]
                badges: data.badges ?? [],
                // dailyUsageRules (array) - Правила использования по дням [{ dayOfWeek, from, to }]
                dailyUsageRules: Array.isArray(data.dailyUsageRules) ? data.dailyUsageRules.map(r => ({
                  dayOfWeek: r.dayOfWeek ?? null,
                  from: r.from ?? '',
                  to: r.to ?? ''
                })) : []
              }
              this.normalizeI18n()
            } else {
              notify({duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: 'Что-то пошло не так!',
              });
            }
          })
          .catch(err => {
            notify({duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message,});
          })
          .finally(() => this.loaded = false)
    },
    normalizeI18n() {
      const requiredLocales = ['ru-RU', 'uz-UZ', 'en-US']
      
      if (!this.ticket.label) {
        this.ticket.label = { value: null, i18n: [] }
      }
      if (!this.ticket.label.i18n || !Array.isArray(this.ticket.label.i18n)) {
        this.ticket.label.i18n = []
      }
      this.ensureI18nLocales(this.ticket.label.i18n, requiredLocales, (locale) => ({ locale, value: null }))
      
      if (!this.ticket.nominal) {
        this.ticket.nominal = { value: 0, currencyCode: null, currency: null }
      }
      if (!this.ticket.nominal.currency) {
        this.ticket.nominal.currency = { code: null, label: null, description: null, image: null, i18n: [] }
      }
      if (!this.ticket.nominal.currency.i18n || !Array.isArray(this.ticket.nominal.currency.i18n)) {
        this.ticket.nominal.currency.i18n = []
      }
      this.ensureI18nLocales(this.ticket.nominal.currency.i18n, requiredLocales, (locale) => ({ 
        locale, 
        label: null, 
        description: null, 
        image: null 
      }))
      
      if (!this.ticket.badges || !Array.isArray(this.ticket.badges)) {
        this.ticket.badges = []
      }
      this.ticket.badges.forEach(badge => {
        if (!badge.i18n || !Array.isArray(badge.i18n)) {
          badge.i18n = []
        }
        this.ensureI18nLocales(badge.i18n, requiredLocales, (locale) => ({ locale, value: null }))
      })

      if (!this.ticket.dailyUsageRules || !Array.isArray(this.ticket.dailyUsageRules)) {
        this.ticket.dailyUsageRules = []
      }
      this.ticket.dailyUsageRules.forEach(rule => {
        if (rule.dayOfWeek === undefined) rule.dayOfWeek = null
        if (rule.from === undefined) rule.from = ''
        if (rule.to === undefined) rule.to = ''
      })
    },
    ensureI18nLocales(i18nArray, requiredLocales, createItem) {
      requiredLocales.forEach(locale => {
        const exists = i18nArray.some(item => item && item.locale === locale)
        if (!exists) {
          i18nArray.push(createItem(locale))
        }
      })
      i18nArray.sort((a, b) => {
        const indexA = requiredLocales.indexOf(a.locale)
        const indexB = requiredLocales.indexOf(b.locale)
        if (indexA === -1) return 1
        if (indexB === -1) return -1
        return indexA - indexB
      })
    },
    getCurrencyLabel(option) {
      if (!option) return ''
      const code = option.code || ''
      // Поддержка разных вариантов: description, label, title
      const description = option.description || option.label || option.title || ''
      return code && description ? `(${code}) ${description}` : (code || description || '')
    },
    onCurrencySelected(option) {
      if (option && this.dCurrency) {
        const selectedCurrency = this.dCurrency.find(item => item.code === option.code)
        if (selectedCurrency) {
          this.ticket.nominal.currency = {
            code: selectedCurrency.code ?? null,
            label: selectedCurrency.label ?? null,
            description: selectedCurrency.description ?? null,
            image: selectedCurrency.image ?? null,
            i18n: selectedCurrency.i18n ?? []
          }
          // Синхронизируем currencyCode для отправки на сервер
          this.ticket.nominal.currencyCode = selectedCurrency.code ?? null
        }
      }
    },
    getI18nItemByLocale(i18nArray, locale) {
      if (!i18nArray || !Array.isArray(i18nArray)) {
        return { locale, value: null, label: null, description: null, image: null }
      }
      let item = i18nArray.find(item => item && item.locale === locale)
      if (!item) {
        // Определяем структуру по первому элементу массива или создаем базовую
        const firstItem = i18nArray[0]
        if (firstItem && ('label' in firstItem || 'description' in firstItem || 'image' in firstItem)) {
          item = { locale, label: null, description: null, image: null }
        } else {
          item = { locale, value: null }
        }
        i18nArray.push(item)
      }
      return item
    },
    prepareTicketData(isCreate = false) {
      this.normalizeI18n()
      
      // Порядок полей соответствует формату обновления из API
      const ticketData = {
        code: this.ticket.code ?? null,
        validityPeriod: this.ticket.validityPeriod ?? 0,
        validityPeriodUnit: this.ticket.validityPeriodUnit ?? null,
        label: {
          value: this.ticket.label?.value ?? null,
          i18n: (this.ticket.label?.i18n ?? []).filter(item => item && item.value)
        },
        icon: this.ticket.icon ?? null,
        background: this.ticket.background ?? null,
        badges: (this.ticket.badges ?? []).map(badge => ({
          code: badge?.code ?? null,
          value: badge?.value ?? null,
          i18n: (badge?.i18n ?? []).filter(item => item && item.value)
        })).filter(badge => badge && (badge.code || badge.value || (badge.i18n && badge.i18n.length > 0))),
        dailyUsageRules: (this.ticket.dailyUsageRules ?? []).map(rule => {
          const from = rule?.from != null && String(rule.from).trim() !== '' ? String(rule.from).trim() : null
          const to = rule?.to != null && String(rule.to).trim() !== '' ? String(rule.to).trim() : null
          return { dayOfWeek: rule?.dayOfWeek ?? null, from, to }
        }).filter(rule => rule && rule.from != null && rule.to != null)
      }
      
      if (isCreate) {
        // Для создания порядок полей: id, code, validityPeriod, validityPeriodUnit, label, icon, background, badges, nominal
        // nominal должен быть объектом только с value и currencyCode (без currency и color)
        const createData = {
          id: this.ticket.id ?? null,
          code: ticketData.code,
          validityPeriod: ticketData.validityPeriod,
          validityPeriodUnit: ticketData.validityPeriodUnit,
          label: ticketData.label,
          icon: ticketData.icon,
          background: ticketData.background,
          badges: ticketData.badges,
          dailyUsageRules: ticketData.dailyUsageRules,
          nominal: {
            value: this.ticket.nominal?.value ?? 0,
            currencyCode: this.ticket.nominal?.currencyCode ?? this.ticket.nominal?.currency?.code ?? null
          }
        }
        return createData
      } else {
        // Для обновления nominal - просто число (вставляем на второе место после code)
        const nominalValue = this.ticket.nominal?.value ?? 0
        // Создаем новый объект с правильным порядком полей
        const updateData = {
          code: ticketData.code,
          nominal: nominalValue,
          validityPeriod: ticketData.validityPeriod,
          validityPeriodUnit: ticketData.validityPeriodUnit,
          label: ticketData.label,
          icon: ticketData.icon,
          background: ticketData.background,
          badges: Array.isArray(ticketData.badges) ? ticketData.badges : [],
          dailyUsageRules: Array.isArray(ticketData.dailyUsageRules) ? ticketData.dailyUsageRules : []
        }
        return updateData
      }
    },
    addBadge() {
      const defaultLocales = ['ru-RU', 'uz-UZ', 'en-US']
      const defaultBadge = {
        code: null,
        value: null,
        i18n: defaultLocales.map(locale => ({
          locale,
          value: null
        }))
      }
      if (!this.ticket.badges || !Array.isArray(this.ticket.badges)) {
        this.ticket.badges = []
      }
      this.ticket.badges.push(defaultBadge)
    },
    removeBadge(index) {
      if (!this.ticket.badges || !Array.isArray(this.ticket.badges)) return
      if (this.ticket.badges.length === 0) return
      this.ticket.badges.splice(index, 1)
    },
    addDailyUsageRule() {
      if (!this.ticket.dailyUsageRules || !Array.isArray(this.ticket.dailyUsageRules)) {
        this.ticket.dailyUsageRules = []
      }
      this.ticket.dailyUsageRules.push({ dayOfWeek: null, from: '', to: '' })
    },
    removeDailyUsageRule(index) {
      if (!this.ticket.dailyUsageRules || !Array.isArray(this.ticket.dailyUsageRules)) return
      if (this.ticket.dailyUsageRules.length === 0) return
      this.ticket.dailyUsageRules.splice(index, 1)
    },
    updateTicket() {
      this.saving = true
      const ticketData = this.prepareTicketData(false)
      
      axios.put('/api/v1/billing/issuer/tickets/specs/' + this.ticketId, ticketData)
          .then(res => {
            if (res.data) {
              notify({duration: 7000, type: 'success', speed: 1000, title: 'Успешно', text: 'Абонемент успешно обновлен!',});
              this.closeModal(true)
            } else {
              notify({duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: 'Что-то пошло не так!',});
            }
          })
          .catch(err => {
            notify({duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message,});
          })
          .finally(() => this.saving = false)
    },
    createTicket() {
      this.saving = true
      const ticketData = this.prepareTicketData(true)
      
      axios.post('/api/v1/billing/issuer/tickets/specs', ticketData)
          .then(res => {
            if (res.data) {
              notify({duration: 7000, type: 'success', speed: 1000, title: 'Успешно', text: 'Абонемент успешно создан!',});
              this.closeModal(true)
            } else {
              notify({duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: 'Что-то пошло не так!',});
            }
          })
          .catch(err => {
            notify({duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message,});
          })
          .finally(() => this.saving = false)
    },
  },
  watch: {
    ticketId: {
      immediate: true,
      handler(val) {
        if (val) this.getTicketItem()
      }
    },
    'ticket.nominal.currency.code'(newVal) {
      // Автоматически синхронизируем currencyCode при изменении currency.code
      if (newVal && this.ticket.nominal) {
        this.ticket.nominal.currencyCode = newVal
      }
    }
  }
}
</script>

<style scoped>

</style>